import React, {lazy, Suspense} from 'react';
import ErrorBoundary from '../../_modules/error/error_boundary';
import { handleView } from '../handle_view';
import CmsLightboxStore from '../../_flux/stores/cms_lightbox_store';
import { hide } from '../../_flux/actions/cms_lightbox_actions';

const CmsLightboxComponent = React.lazy( () =>  import('../../_flux/components/cms_lightbox/cms_lightbox'));
const render = ({ state }, options) => (
    <ErrorBoundary>
        <Suspense fallback={<div>Loading...</div>}>
            <CmsLightboxComponent
                visible={state.visible}
                headline={state.headline}
                subHeadline={state.subHeadline}
                footerText={state.footerText}
                footerCloseText={state.footerCloseText}
                onClose={hide}
            />
        </Suspense>
    </ErrorBoundary>
);

const stores = {
    state: CmsLightboxStore,
};

export const init = (container) =>
    handleView(stores, render, {}, container);
